<template>
  <div>
    <Header
      :showRegistrationModal="showRegistrationModal"
      :showLoginModal="showLoginModal"
      @openRegModal="openRegModal"
      @openLogModal="openLogModal"
    >
    </Header>
    <div class="g-get-touch mt-5" id="contact">
      <v-container grid-list-xl>
        <v-layout row justify-center>
          <v-flex md7>
            <v-progress-linear :indeterminate="sendMessageProgress" v-if="sendMessageProgress"/>
            <h2 class="g-title text-xs-center mt-5">{{ $t('get_in_touch') }}</h2>
          </v-flex>
        </v-layout>
        <v-form class="contactUs" v-model="valid" v-on:submit.prevent="sendMessage" ref="contactUsForm">
          <v-layout row wrap>
            <v-flex lg5>
              <v-flex class="ex-flat-field">
                <label class="ex-flat-label">{{ $t('full_name') }}</label>
                <v-text-field
                  class="rounded-input"
                  v-model="emailData.name"
                  :rules="nameRules"
                  required
                  filled
                  rounded
                  dense
                />
                <p style="color: red">{{errors.nameError}}</p>
                <label class="ex-flat-label">{{ $t('email') }}</label>
                <v-text-field
                  class="rounded-input"
                  v-model="emailData.email"
                  :rules="emailRules"
                  required
                />
                <p style="color: red">{{errors.emailError}}</p>
                <label class="ex-flat-label">{{ $t('mobile') }}</label>
                <v-text-field
                  class="rounded-input"
                  v-model="emailData.mobile"
                  :rules="phoneNumberRules"
                />
                <p style="color: red">{{errors.phoneError}}</p>
                <label class="ex-flat-label">{{ $t('subject') }}</label>
                <v-text-field
                  class="rounded-input"
                  v-model="emailData.subject"
                  :rules="subjectRules"
                  required
                />
                <p style="color: red"> {{errors.subjectError}} </p>
                <label class="ex-flat-label">{{ $t('enter_your_message') }}</label>
                <v-textarea
                  class="text-area"
                  v-model="emailData.message"
                  :rules="messageRules"
                  textarea
                  rows="10"
                  no-resize
                  required
                >
                </v-textarea>
                <p style="color: red"> {{errors.messageError}} </p>
                <div class="d-flex justify-content-between terms cond-term-checkbox mt-3">
                  <label class="container-checkbox">
                    <input type="checkbox" class="checkbox" id="checkbox" ref="checkbox" v-model="emailData.checkbox"
                           @change="checked($event)">
                    <span class="ml-1 agree">{{ $t('agree') }} </span><a>
                    <router-link to="/terms-and-conditions" target="_blank" class="ml-2 one" exact>
                      {{ $t('termsss') }}
                    </router-link>
                  </a>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <span class="mt-5 ml-4 pl-1 errormessage">{{ ckderror }}</span>
                <v-layout row justify-center>
                  <template
                    v-if="emailData.subject && emailData.name && emailData.email && emailData.message && emailData.checkbox">
                    <vue-recaptcha :sitekey="sitekey"
                                   ref="recaptcha"
                                   @verify="markRecaptchaAsVerified"
                                   :loadRecaptchaScript="true"></vue-recaptcha>
                  </template>
                </v-layout>
                <v-layout row justify-center>
                  <span style="color: red">{{ contactForm.pleaseTickRecaptchaMessage }}</span>
                </v-layout>
                <v-card-actions class="modal-btn-sect">
                  <v-btn class="cancel-request-btn2r send-request-btn g-middle-btn" @click="clearMessage">{{
                      $t('clear')
                    }}
                  </v-btn>
                  <v-btn type="submit" class="send-request-btn g-middle-btn" :disabled="disableSend">
                    {{ $t('send_message') }}
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex lg6 class="d-flex align-center justify-center mt-5">
              <div class="info-block mt-3">
                <img src="../../assets/images/get-in-touch.jpg" alt="Mission image">
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </div>
  </div>
</template>

<script>
import {validateEmail} from '../../helpers/main'
import VueRecaptcha from 'vue-recaptcha'
import Header from '../../components/global/Header.vue'

export default {
  components: {VueRecaptcha, Header},
  name: 'get-in-touch',
  // props: ['settings'],
  data: () => ({
    errors: {},
    showRegistrationModal: false,
    showLoginModal: false,
    contactForm: {
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: ''
    },
    sitekey: '6LdMDsoZAAAAAE62BHDPIaOx9Ytb2O4WCyW0XrYw',
    responseRecaptchaToken: '',
    valid: false,
    disableSend: false,
    sendMessageProgress: false,
    ckderror: '',
    emailData: {
      name: '',
      email: '',
      mobile: '',
      subject: '',
      message: '',
      checkbox: ''
    }
  }),
  computed: {
    nameRules () {
      return [
        v => !!v || this.$t('field_is_required')
      ]
    },
    emailRules () {
      return [
        v => !!v || this.$t('field_is_required'),
        v => validateEmail(v) || this.$t('email_must_be_valid')
      ]
    },
    subjectRules () {
      return [
        v => !!v || this.$t('field_is_required')
      ]
    },
    messageRules () {
      return [
        v => !!v || this.$t('field_is_required')
      ]
    },
    phoneNumberRules () {
      return [
        v => (!v || /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    }
  },
  methods: {
    checked (e) {
      if (e.target.checked) {
        this.ckderror = ''
      } else {
        this.ckderror = this.$t('agree_terms')
      }
    },
    openRegModal () {
      this.showRegistrationModal = !this.showRegistrationModal
    },
    openLogModal () {
      this.showLoginModal = !this.showLoginModal
    },
    markRecaptchaAsVerified (response) {
      this.responseRecaptchaToken = response
      this.contactForm.pleaseTickRecaptchaMessage = ''
      this.contactForm.recaptchaVerified = true
    },
    sendMessage () {
      if (!this.contactForm.recaptchaVerified) {
        this.contactForm.pleaseTickRecaptchaMessage = this.$t('recaptcha')
        return true
      }
      if (!this.emailData.checkbox) {
        this.ckderror = this.$t('agree_terms')
      }
      if (this.$refs.contactUsForm.validate()) {
        this.snackbar = true
        this.disableSend = true
        this.sendMessageProgress = true
        this.emailData.recaptchaToken = this.responseRecaptchaToken
        this.$store.dispatch('common/sendEmailContactUs', {emailData: this.emailData})
          .then((res) => {
            if (res.errors) {
              this.errors = res.errors
            }
            if (res.success) {
              this.$toastr('success', this.$t('success'), this.$t('email_sent'))
              this.clearMessage()
              this.$refs.contactUsForm.reset()
            } else if (res.error) {
              this.$toastr('error', this.$t('something_went_wrong'), '')
            }
            this.disableSend = false
            this.sendMessageProgress = false
          })
          .catch(console.error)
      }
    },
    clearMessage () {
      this.$refs.contactUsForm.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/sass/desktop/mainPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/welcomePage/GetInTouch.vue